module.exports = __webpack_public_path__ + "img/antes_despues_220.5c08e27f.png";